<template>
  <h3 class="text-black font-black text-uppercase mb-14">
    {{ __('your_order_title') }}
  </h3>

  <div class="mb-20">
    <slot />
  </div>
</template>
